var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5828 3.22417L15.5972 2.2298C16.1095 1.71755 16.1296 1.16513 15.6776 0.703097L15.3361 0.361598C14.8841 -0.0903869 14.3317 -0.0401663 13.8194 0.451995L12.805 1.4564L14.5828 3.22417ZM2.74081 15.0359L0.420622 15.9299C0.179564 16.0303 -0.0715386 15.7491 0.0188583 15.508L0.973048 13.2782L11.9412 2.32012L13.6989 4.08788L2.74081 15.0359Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Pencil.a6bd418afa1fbe0925bb713bcf303fef.svg";